<template>
  <button
    class="boost-active-value-tag"
    type="button"
  >
    <div
      v-if="option.includes('pf_opt_color')"
      class="boost-facet__swatch"
      :class="{ 'boost-facet__swatch--white': choice.toLowerCase().includes('white') }"
      :style="{ backgroundImage: image }"
    />

    <div
      class="boost-facet__value--key"
      :class="{ 'size-value': option.includes('pf_opt_size') }"
      v-text="formatTitle(value)"
    />

    <div class="boost-active-value-tag__close">
      <span
        class="visually-hidden"
        v-text="$string('accessibility.close')"
      />

      <icon-close />
    </div>
  </button>
</template>

<script>

/**
 * Vue: Boost active value tag (main-collection)
 * -----------------------------------------------------------------------------
 * Tag shown under collection filters with active value.
 *
 * @param {String} choice - Formatted URL param for choice.
 * @param {String} image - Swatch image URL.
 * @param {Object} sortByOptions - Options for sorting.
 *
 */
import IconClose from '~icons/misc/close.svg'

export default {
  name: 'BoostActiveValueTag',

  components: {
    IconClose,
  },

  props: {
    choice: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    sortByOptions: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      option: '',
      value: '',
    }
  },

  watch: {

    /**
     * Watch choice change to split it.
     */
    choice() {
      this.splitChoice()
    },
  },

  mounted() {
    this.splitChoice()
  },

  methods: {

    /**
     * Handle generating tag label for 'sort by' options.
     */
    handleSortChoice() {
      const sortValue = this.choice.split('=')[1]
      const option = Object.values(this.sortByOptions).find((obj) => obj.id === sortValue)

      this.value = option.label
    },

    /**
     * Split choice string into option and value for use in component.
     */
    splitChoice() {
      this.option = this.choice.split('=')[0]

      if (this.option === 'sort') {
        this.handleSortChoice()

        return
      }

      this.value = decodeURI(this.choice.split('=')[1])
    },

    /**
     * Format title for values that include tag content.
     * @param {String} value - Option value.
     * @returns {String}
     */
    formatTitle(value) {
      let title = value

      if (value.includes(':')) {
        title = value.split(':')[1]
      }

      return title
    },
  },
}
</script>

<style lang="scss">
@import './boost-active-value-tag';
</style>
